import { AuthorReleasesList } from '../components/AuthorReleasesList.js';
import { GreetingCard } from '../components/GreetingCard.js';
import { HeatmapCard } from '../components/HeatmapCard.js';
import { KindleCard } from '../components/KindleCard.js';
import { LibraryPreview } from '../components/LibraryPreview.js';
import { QuoteCard } from '../components/QuoteCard.js';
import { ReadingDisplay } from '../components/ReadingDisplay.js';
import { TrendingRow } from '../components/TrendingRow.js';

export function HomePage(): JSX.Element {
  return (
    <div className="flex flex-col gap-6">
      <GreetingCard />
      <div className="flex flex-col gap-6 lg:grid lg:grid-cols-3 lg:gap-8 2xl:grid-cols-12 2xl:gap-10">
        <div className="flex flex-col gap-6 lg:col-span-2 lg:gap-8 2xl:col-span-8">
          <ReadingDisplay />
          <LibraryPreview />
          <TrendingRow />
          <AuthorReleasesList limit={6} />
        </div>
        <aside className="flex flex-col gap-6 lg:gap-8 2xl:col-span-4">
          <HeatmapCard />
          <QuoteCard />
          <KindleCard />
        </aside>
      </div>
    </div>
  );
}
